import { useQuery } from "@tanstack/react-query";

import * as api from "./api";
import useCustomMutation from "src/hooks/useCustomMutation";

export const useGetUserInfo = () => useQuery({
    queryFn: api.getUserInfo,
    queryKey: ["JetCardtUserInfo"]
});

export const useChargeUserByJetCard = () => useCustomMutation({
    mutationFn: api.chargeUserByJetCard
});
